import { useState, Fragment } from "react";
import styles from "./ClientTable.module.scss";
import ModalConfirmation from "../../../../../components/Modal/ModalConfirmation";
import { deleteClient } from "../../../../../api/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import EditClient from "../EditClient/EditClient";

function ClientTable({ clients, setClients }) {
  const [editingClientId, setEditingClientId] = useState(null);
  const [clientIdToDelete, setClientIdToDelete] = useState(null);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleEdit = (clientId) => {
    setEditingClientId(clientId);
  };

  const handleCancelEdit = () => {
    setEditingClientId(null);
  };

  const handleCloseModal = () => {
    setShowDeleteConfirmationModal(false);
  };

  const handleDelete = async (clientIdToDelete) => {
    try {
      const response = await deleteClient(clientIdToDelete);

      if (response.status === 200) {
        const updatedClients = clients.filter(
          (client) => client.id !== clientIdToDelete,
        );

        setClients(updatedClients);

        setShowDeleteConfirmationModal(false);
        setEditingClientId(null);
        setErrorMessage("");
      }
    } catch (error) {
      console.error("Erreur lors de la suppression du client : ", error);
      setErrorMessage(
        error.response?.data?.message ||
          "Une erreur est survenue lors de la suppression du client",
      );
    }
  };

  return (
    <>
      {errorMessage && (
        <div className={styles.errorMessage}>{errorMessage}</div>
      )}
      <table className={styles.tableContainer}>
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Email</th>
            <th>Téléphone</th>
            <th>Adresse</th>
            <th>Date d'inscription</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {clients &&
            clients.map((client) => (
              <Fragment key={client.id}>
                <tr>
                  <td>{client.last_name}</td>
                  <td>{client.first_name}</td>
                  <td>{client.email}</td>
                  <td>{client.phone_number || "-"}</td>
                  <td>{client.address || "-"}</td>
                  <td>
                    {new Date(client.created_at).toLocaleDateString("fr-FR", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </td>
                  <td>
                    <FontAwesomeIcon
                      icon={faPencil}
                      className={styles.icon}
                      onClick={() => handleEdit(client.id)}
                    />
                    <FontAwesomeIcon
                      icon={faTrashCan}
                      className={styles.icon}
                      onClick={() => {
                        setClientIdToDelete(client.id);
                        setShowDeleteConfirmationModal(true);
                      }}
                    />
                  </td>
                </tr>
                {editingClientId && editingClientId === client.id && (
                  <tr>
                    <td colSpan="7">
                      <EditClient
                        clientToEdit={clients.find(
                          (client) => client.id === editingClientId,
                        )}
                        onCancelEdit={handleCancelEdit}
                        setClients={setClients}
                      />
                    </td>
                  </tr>
                )}
              </Fragment>
            ))}
        </tbody>
      </table>

      <ModalConfirmation
        isOpen={showDeleteConfirmationModal}
        onClose={handleCloseModal}
        message="Êtes-vous sûr de vouloir supprimer ce client ?"
        onConfirm={() => handleDelete(clientIdToDelete)}
      />
    </>
  );
}

export default ClientTable;
